import { Box } from '@mui/material';
import React from 'react';
// import ChronicDiseaseIcon from '../../../assets/icons/chronicDisease.svg';
const ArcContainer = ({
  children,
  icon,
  customizedHeight
}: {
  children: any;
  icon: string;
  customizedHeight?: string;
}) => {
  return (
    /* Main white card */
    <Box
      sx={{
        // Just a gray background so you can SEE the “cut-out” arc
        // backgroundColor: '#e0e0e0',
        minHeight: customizedHeight ? customizedHeight : '100vh',
        p: 0,
        display: 'flex',
        marginTop: '1.875rem',
        width: '100%'
      }}
    >
      {/* Card Container (position relative so we can position “arc” & icon) */}
      <Box
        sx={{
          position: 'relative',
          width: '100%', // or '100%'
          mx: 'auto', // center horizontally
          backgroundColor: '#fff',
          borderRadius: 2, // normal rounding for the card
          p: 2,
          boxShadow: 0.5
        }}
        className="p-0"
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: 60,
            height: 30,
            backgroundColor: '#F2F2F2', // Must match the parent background
            borderRadius: '0 0 9999px 9999px'
          }}
        />

        {/* 2) The Icon Circle
            - Absolutely positioned above the arc
            - Slightly bigger than the notch, so it “floats” with a gap */}
        <Box
          sx={{
            position: 'absolute',
            top: -25, // moves it above the card (and above the arc)
            left: '50%',
            transform: 'translateX(-50%)',
            width: 50,
            height: 50,
            borderRadius: '50%',
            backgroundColor: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: 0
            // Add a little border or accent if desired:
            // border: '0.1875rem solid #eee'
          }}
        >
          <Box
            component="img"
            src={icon}
            alt="icon"
            sx={{ width: 24, height: 24 }} // icon size
          />
        </Box>
        {children}
      </Box>
    </Box>
  );
};

export { ArcContainer };
